import React from 'react';
import { Paper, Box, Typography, alpha } from '@mui/material';

// Compact KPI tile — a single headline number + label, used above the chart
// grid on a manager-dashboard statistics page. Shares DashboardCard's visual
// language (border, gradient wash, icon circle) so both sit together cleanly.
const StatTile = ({ label, value, icon: Icon, color = '#2a78d6', caption }) => (
    <Paper
        elevation={0}
        sx={{
            p: 2.5,
            height: '100%',
            boxSizing: 'border-box',
            border: '1px solid rgba(11,11,11,0.08)',
            borderRadius: 4,
            background: `linear-gradient(180deg, ${alpha(color, 0.06)} 0%, #ffffff 90px)`,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
        }}
    >
        {Icon && (
            <Box
                sx={{
                    width: 42,
                    height: 42,
                    borderRadius: '50%',
                    bgcolor: alpha(color, 0.14),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                <Icon sx={{ color, fontSize: 22 }} />
            </Box>
        )}
        <Box sx={{ minWidth: 0 }}>
            <Typography variant="h5" fontWeight={700} sx={{ lineHeight: 1.2 }}>
                {value}
            </Typography>
            <Typography variant="body2" color="text.secondary">{label}</Typography>
            {caption && (
                <Typography variant="caption" color="text.secondary" display="block">{caption}</Typography>
            )}
        </Box>
    </Paper>
);

export default StatTile;
